var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04 4.95a1.25 1.25 0 0 1 1.76-.16l4.314 2.87c.32.213.48.32.653.361a1 1 0 0 0 .466 0c.173-.041.333-.148.653-.36L13.2 4.79a1.25 1.25 0 0 1 1.6 1.92c-.483.403-2.956 2.415-4.78 3.9-.72.584-1.08.876-1.48.988a2 2 0 0 1-1.079 0c-.4-.113-.76-.406-1.479-.992L1.2 6.71a1.25 1.25 0 0 1-.16-1.76Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown16);
export default __webpack_public_path__ + "static/media/dropdown_16.a2bcafbd.svg";
export { ForwardRef as ReactComponent };